<template>
  <div>
    <appHeader></appHeader>
    <div class="container-fluid add-client">
      <div class="row">
        <div class="col-md-3 col-sm-12 pr-0 dark-bg">
          <appAdminSidebar></appAdminSidebar>
        </div>
        <router-view />
      </div>
    </div>
    <appFooter></appFooter>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import divvyAdminSidebar from '@/views/divvyadmin/divvyAdminSidebar.vue';
import Footer from '@/components/Footer.vue';

export default {
  name: 'BusinessUnits',
  components: {
    appHeader: Header,
    appAdminSidebar: divvyAdminSidebar,
    appFooter: Footer,
  },

  methods: {
    setActiveMenuItem: function() {
      this.$store.dispatch('divvyAdminSidebar/setActive', {
        activeMenuItem: this.activeMenuItem ? this.activeMenuItem : 'businessUnits',
        activeMenu: this.activeMenu ? this.activeMenu : 'clientusermanagement',
      });
    },
  },

  created() {
    this.setActiveMenuItem();
  },
};
</script>
<style lang="scss" scoped>
.add-client {
  //   margin: 70px 0 0 0;
  min-height: 100%;
  margin: -14px 0 0 0;
  .badge {
    font-size: 0.8rem;
    padding: 6px 0px;
    border-radius: $border-radius-sm;
  }
}
.marginAll {
  margin: 10px;
}

html,
body {
  height: 100%;
}
</style>
